import { ServiceProviderDetailSidebar } from 'application/components/building_blocks/sidebar'
import React from 'react'

const ProviderPopupSidebarComponent = props => {
    return <ServiceProviderDetailSidebar {...props} />
}

export default ProviderPopupSidebarComponent
